@if (widgetVM$ | async; as vm) {
  <bp-tile
    [title]="'portfolio_greeting' | translate: [vm.profile.forename]"
    (headerClickEvent)="goToProfile()"
    [isHeaderClickable]="true"
    [css]="'content-portfolio'">
    @if (vm.portfolioData; as portfolioData) {
      <div class="portfolio-widget-container">
        @if (!vm.isLoading && !vm.apiError) {
          <div class="portfolio-widget-value portfolio-widget-value-sum mod-ff-aspect" (click)="goToWalletHome()">
            <span>{{ "portfolio_widget_title" | translate }}</span>
            <span hidePortfolioValue [isHideActive]="vm.isHidePortfolioValueActive">
              {{
              portfolioData.projection.currentValue
              | fiat_precision_symbol
              : {
              id: defaultFiat?.getId(),
              currencies: [defaultFiat],
              symbol: true
            }
            }}
          </span>
        </div>
        <portfolio-performance
          class="portfolio-widget-chart"
          [portfolioData]="portfolioData"
          [timeFrameOptions]="vm.timespanOptions"
          [fiat]="defaultFiat"
          [language]="vm.language"
          (onTimeframeSelected)="updateTime($event)">
        </portfolio-performance>
      }
      <!-- Template for showing either the loading or error status for portfolio API -->
      @if (vm.isLoading && !vm.apiError) {
        <div class="portfolio-widget-value">
          <div class="portfolio-widget-value-big">
            <span class="portfolio-widget-value-big-sum loading">
              <bp-price-loading [fiat]="defaultFiat"></bp-price-loading>
            </span>
          </div>
        </div>
      }
      @if (vm.apiError) {
        <div class="portfolio-widget-error">
          <bp-info-box>{{ "portfolio_load_error" | translate }}</bp-info-box>
        </div>
      }
      @if (!vm.isLoading && !vm.apiError) {
        <div class="portfolio-widget-charts">
          <div class="portfolio-widget-chart-keys">
            @if (!isUnverified()) {
              <ng-container [ngTemplateOutlet]="fiatSum"></ng-container>
            }
            @for (c of vm.assets; track c; let isLastItem = $last) {
              <div
                class="portfolio-widget-key"
                (click)="openAssetDetail(c.id)"
                (keydown.enter)="openAssetDetail(c.id)"
                [tabindex]="0">
                <!-- Icon & Currency -->
                <div class="portfolio-widget-key-currency">
                  <img
                    class="image-size"
                    [src]="c.logo"
                    alt="{{ 'logo_alt_text' | translate }}"
                    #img />
                  <div class="portfolio-widget-key-currency-text">
                    <strong>{{ c.name }}</strong>
                  </div>
                  @if (c.isLegacyDigiAsset) {
                    <div class="legacy-label-container">
                      <legacy-label></legacy-label>
                    </div>
                  }
                </div>
                <!-- Amount -->
                <div class="portfolio-widget-key-amount">
                  <div
                    class="portfolio-widget-key-amount-assets"
                    hidePortfolioValue
                    [isHideActive]="vm.isHidePortfolioValueActive">
                    {{
                    c.fiatBalance
                    | fiat_precision_symbol
                    : {
                    id: defaultFiat?.getId(),
                    currencies: [defaultFiat],
                    symbol: true
                  }
                  }}
                </div>
              </div>
            </div>
            <!-- Show all button & fade -->
            @if (isLastItem && vm.assetCount >= maxItemsShown) {
              <div
                id="showAll"
                class="portfolio-widget-show-all"
                (click)="goToWalletHome()">
                <span
                  class="portfolio-widget-show-all-link"
                  [tabindex]="0"
                  (keydown.enter)="goToWalletHome()">
                  {{ "my_portfolio_to_wallet_dashboard" | translate }}
                </span>
              </div>
            }
          }
        </div>
      </div>
    }
  </div>
}
</bp-tile>
<ng-template #fiatSum>
  <div
    class="portfolio-widget-key"
    (click)="goToFiatCurrency()"
    (keydown.enter)="goToFiatCurrency()"
    [tabindex]="0">
    <!-- Icon & Currency -->
    <div class="portfolio-widget-key-currency">
      <img
        class="image-size"
        [src]="defaultFiat.getLogo()"
        (error)="img.src = defaultFiat.getDefaultLogo()"
        alt="{{ 'logo_alt_text' | translate }}"
        #img />
      <div class="portfolio-widget-key-currency-text">
        <strong>{{ "cash" | translate }}</strong>
      </div>
    </div>
    <!-- Amount -->
    <div class="portfolio-widget-key-amount">
      <div
        class="portfolio-widget-key-amount-fiat"
        hidePortfolioValue
        [isHideActive]="vm.isHidePortfolioValueActive">
        <strong>
          {{
          +vm.fiatSum
          | fiat_precision_symbol
          : { id: defaultFiat?.getId(), currencies: [defaultFiat], symbol: true }
          }}
        </strong>
      </div>
    </div>
  </div>
</ng-template>
}
